import { z } from 'zod';
import { patronDeCadenciaSchema } from './cadencia.js';
import { EXTENSION_DIAS_MAXIMO, EXTENSION_DIAS_MINIMO } from './protocolo.js';
/**
 * Contrato de los ajustes del programa · acciones del equipo clínico.
 *
 * Las tres son decisiones de una persona sobre el seguimiento de otra, así que
 * las tres piden **motivo**: sin él, el timeline del paciente muestra que algo
 * cambió y no por qué, que es la mitad inútil de una auditoría.
 */
export const ajustarIntensidadSchema = z.strictObject({
    patron: patronDeCadenciaSchema,
    motivo: z.enum(['buena_evolucion', 'desvio_relevante', 'decision_clinica', 'pedido_paciente']),
    /** Un ajuste temporal declara hasta cuándo. */
    temporal: z.boolean(),
    hastaAt: z.iso.datetime().nullable(),
});
export const excluirItemSchema = z.strictObject({
    /** Código del ítem en el protocolo. Sólo los opcionales se pueden excluir. */
    codigo: z.string().min(1).max(40),
    /**
     * Por qué. Texto libre corto y **del profesional, no del paciente**: es la
     * justificación clínica de la decisión, del mismo orden que la de una nota.
     */
    motivo: z.string().min(3).max(200),
});
export const extenderProgramaSchema = z.strictObject({
    /** El protocolo la define como 3 a 6 meses adicionales. */
    dias: z.number().int().min(EXTENSION_DIAS_MINIMO).max(EXTENSION_DIAS_MAXIMO),
});
export const resultadoDelAjusteSchema = z.strictObject({
    programaId: z.uuid(),
    itemsCreados: z.number().int().nonnegative(),
    itemsEliminados: z.number().int().nonnegative(),
});
//# sourceMappingURL=api.js.map